
import { defineComponent } from 'vue'

interface InstallationMethod {
  label: 'cURL' | 'Homebrew'
  value: 'curl' | 'brew'
}

export default defineComponent({
  name: 'EnableCoverageSteps',
  props: {
    dsn: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      chevronIconAnimateClass: '',
      installationMethod: 'curl' as InstallationMethod['value']
    }
  },
  computed: {
    cliCommand(): string {
      return './bin/deepsource report --analyzer test-coverage --key <key> --value-file <absolute-path-of-the-coverage report>'
    },
    installationMethodList(): Array<InstallationMethod> {
      return [
        { label: 'cURL', value: 'curl' },
        { label: 'Homebrew', value: 'brew' }
      ]
    },
    installationCommand(): string {
      return this.installationMethod === 'curl'
        ? 'curl deepsource.io/cli | sh'
        : 'brew install deepsourcelabs/cli/deepsource'
    }
  },
  methods: {
    isOpenHandler(open: boolean): void {
      this.chevronIconAnimateClass = open
        ? 'animate-first-quarter-spin rotate-90'
        : 'animate-reverse-quarter-spin rotate-0'
    }
  }
})
